module.exports = __webpack_public_path__ + "static/media/proceduresStep.2aa05dbf.svg";